import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

// TODO: Replace with your actual Firebase config keys from the console
// You can find these in Project Settings > General > Your apps
const firebaseConfig = {
  apiKey: "AIzaSyAgaGAag-cAhJwb907nFKyE60PNV_xUhsk",
  authDomain: "sushi-koi-bb979.firebaseapp.com",
  projectId: "sushi-koi-bb979",
  storageBucket: "sushi-koi-bb979.firebasestorage.app",
  messagingSenderId: "425272549599",
  appId: "1:425272549599:web:0abb6ffca8e9826124496a",
  measurementId: "G-1HELHE53E0"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const analytics = typeof window !== "undefined" ? getAnalytics(app) : null;
